import { Link } from 'react-router-dom';
import Figure from 'assets/images/content/app-figure.svg';
import { Header } from './Header';
import Pdf from 'assets/pdf/1.pdf'
export const MainBlock = () => {

  return (
    <section className='main'>
      <div className='main__bg'>
        <Header />
        <div className='container'>
          <div className='main__top-block'>
            <h1 className='main__title'>Лучший дом. Лучший двор</h1>
            <p className='main__caption'>
              II Всероссийский Конкурс лучших практик управления <br />{' '}
              многоквартирными домами
            </p>
          </div>
          <div className='main__bottom-block'>
            <div className='main__left-block'>
              <p className='main__text'>
                Всем известна ставшая крылатой фраза из&nbsp;советского фильма
                «Управдом&nbsp;— друг человека». В&nbsp;регионах страны
                есть&nbsp;немало примеров того, как&nbsp;собственники
                совместно с&nbsp;профессиональными управляющими компаниями
                сделали свои многоквартирники «домами образцового содержания».
                Найти самых талантливых из&nbsp;них&nbsp;и&nbsp;показать всем
                лучшие примеры реализации проектов по&nbsp;совершенствованию
                процесса управления многоквартирными домами&nbsp;— задача,
                которую поставили перед&nbsp;собой организаторы конкурса
                и&nbsp;его&nbsp;партнёры.
              </p>
              <div className="main__btn-flex">
                <Link to={'/voting'}>
                  <button className='main__btn button button_clear'>
                    Смотреть заявки
                  </button>
                </Link>
                <a
								href={Pdf}
								target={'_blank'}
								rel='noreferrer'
                style={{textDecoration:'none'}}
							>
								<button className='main__btn button file'  type='button'>Протокол жюри</button>
							</a>

                {/* <Link to="/voting">
                                    <button className='main__btn button button_clear'>Проголосовать</button>
                                </Link> */}
              </div>
            </div>
            <div className='main__right-block'>
              <div className='main__app-figure'>
                <img src={Figure} alt='' />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
